import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useUserMenuStyles = makeStyles((theme) =>
  createStyles({
    activeLink: {
      '& *': {
        color: theme.palette.primary.main
      }
    },

    avatar: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      backgroundColor: theme.palette.grey.A400,
      textDecoration: 'none'

      // [theme.breakpoints.down('md')]: {
      //   width: theme.spacing(6),
      //   height: theme.spacing(6),
      //   marginLeft: 16,
      //   marginTop: 40,
      //   marginBottom: 20
      // }
    },

    logoLink: {
      marginTop: '46px',
      marginLeft: '18px'
    },

    userInfo: {
      marginLeft: 16,
      maxWidth: 290
    },

    headerLang: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between'
    },

    lang: {
      display: 'flex',
      alignItems: 'center'
    },

    btnRu: {
      fontFamily: 'Montserrat',
      fontSize: 14,
      textTransform: 'none',
      minWidth: 34,
      minHeight: 20
    },

    btnEng: {
      fontFamily: 'Montserrat',
      fontSize: 14,
      textTransform: 'none',
      minWidth: 44,
      minHeight: 20,
      marginRight: 11
    },

    linkDivider: {
      height: 16,
      borderRight: '1px solid #9E9E9E'
    },

    menu: {
      width: 360,

      [theme.breakpoints.down('md')]: {
        width: 300
      }
    },

    iconExit: {
      minWidth: 20
    },

    link: {
      textDecoration: 'none'
    },

    buttonAuth: {
      marginLeft: 10
    },

    poper: {
      marginRight: 20
    },

    drawer: {
      ['@media (min-width: 1440px)']: {
        display: 'none'
      }
    },

    icon: {
      marginRight: 20,

      [theme.breakpoints.down('md')]: {
        marginRight: 35
      }
    },

    exit: {
      '& .MuiTypography-body1': {
        fontWeight: 600,
        fontFamily: 'Montserrat',
        fontSize: 15
      }
    }
  })
)
